import { MarkButton } from '../MarkControls';
import React from 'react';
type Props = {
    index: number;
    total: number;
    onMoveUp: () => void;
    onMoveDown: () => void;
    onDuplicate: () => void;
    onDelete: () => void;
    // When set, Copy is disabled and this explains why.
    duplicateDisabledReason?: string;
    parentLabel?: string;
};
const BlockToolbar: React.FC<Props> = ({
    index,
    total,
    onMoveUp,
    onMoveDown,
    onDuplicate,
    onDelete,
    duplicateDisabledReason,
    parentLabel
}) => {
    const isFirst = index === 0;
    const isLast = index === total - 1;
    const disableDuplicate = Boolean(duplicateDisabledReason);
    const prefix = parentLabel ? `${parentLabel}, ` : '';
    const buttonStyle: React.CSSProperties = {
        padding: '0.2rem 0.6rem',
        fontSize: '1.1rem',
        border: '1px solid var(--mark-border)',
        borderRadius: '0.3rem',
        backgroundColor: 'var(--mark-border)',
        cursor: 'pointer',
        lineHeight: 1.4
    };
    const disabledStyle: React.CSSProperties = {
        ...buttonStyle,
        opacity: 0.4,
        cursor: 'not-allowed'
    };
    return (
        <div
            data-block-toolbar={index}
            style={{
                display: 'flex',
                gap: '0.4rem',
                marginBottom: '0.6rem'
            }}
        >
            <MarkButton
                type="button"
                aria-label={`${prefix}Move block ${index + 1} up`}
                title={isFirst ? 'Already the first block' : 'Move up'}
                onClick={onMoveUp}
                disabled={isFirst}
                style={isFirst ? disabledStyle : buttonStyle}
            >
                ↑
            </MarkButton>
            <MarkButton
                type="button"
                aria-label={`${prefix}Move block ${index + 1} down`}
                title={isLast ? 'Already the last block' : 'Move down'}
                onClick={onMoveDown}
                disabled={isLast}
                style={isLast ? disabledStyle : buttonStyle}
            >
                ↓
            </MarkButton>
            <MarkButton
                type="button"
                aria-label={`${prefix}Duplicate block ${index + 1}`}
                title={duplicateDisabledReason ?? 'Duplicate'}
                onClick={onDuplicate}
                disabled={disableDuplicate}
                style={disableDuplicate ? disabledStyle : buttonStyle}
            >
                Copy
            </MarkButton>
            <MarkButton
                type="button"
                aria-label={`${prefix}Delete block ${index + 1}`}
                title="Delete"
                onClick={onDelete}
            >
                ✕
            </MarkButton>
        </div>
    );
};
export default BlockToolbar;
